(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alurea-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.alurea-cart__step');
    if (!button) return;
    const form = button.closest('form');
    const input = button.parentElement.querySelector('[data-cart-quantity]');
    input.value = Math.max(0, Number(input.value || 0) + Number(button.dataset.step));
    const submit = document.createElement('input');
    submit.type = 'hidden'; submit.name = 'update'; submit.value = 'Update';
    form.appendChild(submit);
    form.submit();
  });
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.alurea-cart [data-cart-quantity]')) return;
    const form = event.target.closest('form');
    const submit = document.createElement('input');
    submit.type = 'hidden'; submit.name = 'update'; submit.value = 'Update';
    form.appendChild(submit);
    form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roosly-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.roosly-cart__step');
    if (!button) return;
    const form = button.closest('form');
    const input = button.parentElement.querySelector('[data-cart-quantity]');
    input.value = Math.max(0, Number(input.value || 0) + Number(button.dataset.step));
    const submit = document.createElement('input');
    submit.type = 'hidden'; submit.name = 'update'; submit.value = 'Update';
    form.appendChild(submit);
    form.submit();
  });
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.roosly-cart [data-cart-quantity]')) return;
    const form = event.target.closest('form');
    const submit = document.createElement('input');
    submit.type = 'hidden'; submit.name = 'update'; submit.value = 'Update';
    form.appendChild(submit);
    form.submit();
  });

  } catch(e) { console.error(e); }
})();
})();
